<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px',marginLeft:'10px' }"
        @click="addEditTeam"
      >
        新增团队服务商
      </a-button>
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增企业服务商
      </a-button>
    </div>

    <div class="global-table-container">
      <a-tabs
        default-active-key="0"
        @change="changeTab"
      >
        <a-tab-pane
          key="0"
          tab="企业级服务商"
        />
        <a-tab-pane
          key="1"
          tab="团队级服务商"
          force-render
        />
      </a-tabs>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            v-if=" record.fdd_exist_sign === 0"
            text="签章"
            alert-title="确定签章？"
            @onDelete="() => handleSignature(record)"
          />
          <a-divider
            v-if=" record.fdd_exist_sign === 0"
            type="vertical"
          />
          <popconfirm-button
            v-if=" record.fdd_exist_sign === 1"
            :text="record.status === 0 ? '启用' : '禁用'"
            :alert-title="record.status === 0 ? '确定启用？' : '确定禁用？'"
            @onDelete="() => onForbidden(record)"
          />
          <a-divider
            v-if=" record.fdd_exist_sign === 1"
            type="vertical"
          />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <team-modal
      ref="formRef"
      :btn-is-loading="btnIsLoading"
      :visible="teamVisible"
      :title="title"
      @onCancel="onCancelTeam"
      @handleSubmit="handleSubmitTeam"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import TeamModal from './modal/index';
export default {
  components: {TeamModal},
  data() {
    return {
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      businessVisible: false,
      shopSystemVisible: false,
      title: '',
      checkKeyProp: 0,
      tabKey: '0',
      teamVisible: false,
      btnIsLoading: false,
      teamId: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({ company_type: this.tabKey, page: this.current, pageSize: this.pageSize });
  },
  methods: {
    // 点击tab
    changeTab(key){
      this.tabKey=key;
      this.getTableData({ company_type: this.tabKey, page: this.current, pageSize: this.pageSize });

    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/ServiceProvider/getCompanyList',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = params.page;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            companyInfoId: item.info_id,
            status: item.status,
            fdd_exist_sign: item.companyInfo.fdd_exist_sign,
            qichachaname: item.companyInfo.qichacha_name,
            contact: item.companyInfo.qichacha_oper_name,
            phone: item.companyInfo.phone,
            location: item.companyInfo.location,
            createtime: this.$Format(item.companyInfo.create_time),
            company_type: item.companyInfo.company_type,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 新增团队服务商
    addEditTeam(){
      this.teamVisible=true;
      this.title='新增团队服务商';
      this.teamId='';
      this.$nextTick(()=>{
        this.$refs.formRef.$refs.basicForm.form.resetFields();
      });
    },
    // 确认新增团队服务商
    handleSubmitTeam() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('TCL: handleSubmit -> values', values);
          if (!err) {
            this.btnIsLoading=true;
            values.id=this.teamId?this.teamId:undefined;
            // values.province=values.provinceCity.province;
            // values.city=values.provinceCity.city;
            // values.location_path= `0,${values.provinceCity.province},${values.provinceCity.city},`;
            let result = await this.$http.post(
              '/ServiceProvider/teamUpdate',
              values,
            );
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.teamVisible = false;
              this.getTableData({
                company_type: this.tabKey,
                page: this.current,
                pageSize: this.pageSize,
              });
            }
          }
        },
      );
    },
    // 取消新增团队服务商
    onCancelTeam() {
      this.teamVisible = false;
    },
    // 编辑或新增
    editAndAdd(record) {
      if (record.id) {
        if(record.company_type===1){
          this.teamVisible = true;
          this.title='编辑团队服务商';
          this.teamId=record.data.companyInfo.id;
          let data={
            qichacha_name: record.qichachaname,
            qichacha_oper_name: record.contact,
            phone: record.phone,
            provinceCity: {province: record.province, city: record.city},
          };
          this.$nextTick(()=>{
            this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
          });
        }else{
          this.$router.push({ path: '/service/add', query: { id: record.id } });
        }

      } else {
        this.$router.push('/service/add');
      }
    },
    // 取消编辑或新增
    onCancel() {
      this.businessVisible = false;
    },
    // 删除
    async onDelete(record) {
      let result = await this.$http.post('/ServiceProvider/setStatus', {
        id: record.id,
        status: -1,
      });
      if (result.data.status === 1) {
        this.$message.success(result.data.msg);
        this.getTableData({
          company_type: this.tabKey,
          page: this.current,
          pageSize: this.pageSize,
        });
      }
    },
    // 签章
    async handleSignature(record){
      let result = await this.$http.post('/company/fddMakeSign', {
        companyInfoId: record.companyInfoId,
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({
          company_type: this.tabKey,
          page: this.current,
          pageSize: this.pageSize,
        });
      }
    },
    // 禁用 启用
    async onForbidden(record) {
      let result = await this.$http.post('/ServiceProvider/setStatus', {
        id: record.id,
        status: record.status === 0 ? 1 : 0,
      });
      if (result.data.status === 1) {
        this.$message.success(result.data.msg);
        this.getTableData({
          company_type: this.tabKey,
          page: this.current,
          pageSize: this.pageSize,
        });
      }
    },
    // 分页
    changePage(pagination) {
      this.getTableData({
        company_type: this.tabKey,
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
